<!-- <div class="fadeinright animation-duration-200">
  <div class="px-5 pt-4">
    <div class="flex flex-column align-items-center justify-content-center gap-2">
      <p class="font-normal">El agente te puede pedir un código QR </p>
      <qrcode [qrdata]="qrCode" [width]="300" [errorCorrectionLevel]="'M'"></qrcode>

    </div>
    <div class="flex text-center mt-5">
      <h2>¿Realizaste todo el proceso completo?</h2>
    </div>
    <div class="flex w-full justify-content-center mt-5">
      <p-button label="Si, realice todo el proceso" (onClick)="onProgressEnrollment()"></p-button>
    </div>
    <div class="flex flex-column align-items-center justify-content-center gap-2 mt-8">
      <p class="font-normal">Puedes volver al paso anterior si crees que no esta listo </p>
      <p-button severity="secondary" [outlined]="true" label="Volver" icon="pi pi-arrow-left" (onClick)="onReturnEnrollment()"></p-button>
    </div>
  </div>
</div> -->


<p-dialog [(visible)]="visibleModalQRProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Necesitas este código QR</h2>
        </div>
        <div class="dialog__text miniPad">
          <div class="qr-code">
            <div class="qr-code__img big">
              <qrcode [qrdata]="qrCode" [width]="500" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
          </div>
        </div>
        <div class="dialog__btn dialog__block">
          <button pButton pRipple label="Continuar el proceso" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleModalEndProcess=true; visibleModalQRProcess=false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog [(visible)]="visibleModalEndProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¿Realizaste todo el proceso completo?</h2>
          <p>Puedes volver al paso anterior si crees que no estás listo.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Si, realicé todo el proceso" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onProgressEnrollment()"></button>
          <div class="dialog__btnFloat">
            <p-button label="Volver al paso anterior" icon="pi pi-arrow-left" iconPos="left" [text]="true" [plain]="true" (onClick)="onReturnEnrollment()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

